<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:27:59
 * @LastEditors  : M.D.
 * @Description: 常见问题
 * @Remarks:
 -->
<template>
  <div class="q-and-a bShadow-5">
    <div style="width: 300px;right: 0px;height: 50px;display: block;z-index: 99;text-align: right;position: absolute;">
      <input placeholder="搜索问题内容..." editable @input="onInputKeyword" style="height: 32px;width: 220px;background: #F5F5F5;margin: 7px 12px 0 0;font-size: 12px;border-radius: 16px;border: none;padding: 0 12px 0 12px;opacity: 1;"/>
    </div>
    <el-tabs v-model="curTabName" class="ui-tabs ui-custom-s">
      <el-tab-pane name="qa" class="my-msg">
        <span slot="label" class="lb-txt">常见问题</span>
        <ui-list :keyword="keyword" @onclickQa="onclickQa"></ui-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UiList from '@/components/ui-list'
export default {
  props: {

  },
  data () {
    return {
      curTabName: 'qa',
      question: {},
      keyword: ''
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    onclickQa (item) {
      this.question = item
      this.$router.push({
        name: 'qaDetail',
        params: item
      })
    },
    onInputKeyword (event) {
      this.keyword = event.target.value
    }
  },
  components: {
    UiList
  }
}
</script>

<style lang="stylus">
.q-and-a
  height 666px
  box-sizing border-box
  background-color #ffffff
</style>
